import { createFileRoute } from '@tanstack/react-router';

import CustomerManagementPage from '@/areas/customers/Customers/CustomerManagementPage';
import { canViewCustomers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/customers/')({
    staticData: { access: { permissions: canViewCustomers }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CustomerManagementPage />;
}
